module.exports = "/images/avatar-s-24.jpg?e9860ff62971f4dca6eec8ccadad35ad";